import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Popover, Alert } from 'antd';
import cn from 'classnames';
import Cell from '../Cell/Cell';
import Actions from '../Actions/Actions';
import MissedCalls from './components/MissedCalls';
import ActiveCalls from './components/ActiveCalls';
import {
  controlPanelWidth,
  controlPanelId,
  notDraggableClass,
} from '../../constants/common';
import useIntersectionObserver from '../../../../hooks/useIntersectionObserver';
import {
  callDirectionSelector,
  numPadVisibleSelector,
  ringtonePlayErrorSelector,
  subscriberSelector,
  newRequestModalVisibleSelector,
} from '../../store/selectors';
import { callDirectionsText } from '../../constants/callDirections';
import Header from './components/Header';
import PhoneNumberInput from './components/PhoneNumberInput';
import NumPad from '../NumPad/NumPad';
import { setNumPadVisible, setRingtonePlayError } from '../../store/actions';
import SettingsList from '../SettingList/SettingList';
import styles from './ControlPanel.module.scss';
import ChooseCompany from './components/ChooseCompany';
import { useIsDispatcher } from '../../../../hooks/useIsDispatcher';

const ControlPanel = ({ onHide, containerRef, onIntersect }) => {
  const dispatch = useDispatch();

  const callDirection = useSelector(callDirectionSelector);
  const subscriber = useSelector(subscriberSelector);
  const numPadVisible = useSelector(numPadVisibleSelector);
  const ringtonePlayError = useSelector(ringtonePlayErrorSelector);
  const newRequestModalVisible = useSelector(newRequestModalVisibleSelector);

  const isDispatcher = useIsDispatcher();

  const handleCloseNumPadBtnClick = () => {
    dispatch(setNumPadVisible(false));
  };

  const handleAlertClose = () => {
    dispatch(setRingtonePlayError(null));
  };

  useIntersectionObserver({
    target: containerRef,
    onIntersect,
    threshold: 1,
  });

  return (
    <Popover
      content={<NumPad />}
      autoFocus={false}
      title={
        <>
          <h3 className={styles.title}>Тональный набор</h3>
          <Button
            icon="close"
            className={cn(styles.collapseBtn)}
            onClick={handleCloseNumPadBtnClick}
          />
        </>
      }
      visible={numPadVisible}
      placement="rightBottom"
      overlayClassName={cn(styles.popover, notDraggableClass)}
    >
      <div
        className={styles.root}
        id={controlPanelId}
        style={{ width: controlPanelWidth }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
      >
        <Header onClick={onHide} />

        <section className={styles.main}>
          {Boolean(ringtonePlayError) && (
            <Alert
              message="Ошибка при воспроизведении рингтона"
              description={
                ringtonePlayError.name === 'NotAllowedError'
                  ? 'Браузер заблокировал автовоспроизведение рингтона'
                  : 'Возникла ошибка при воспроизведении рингтона'
              }
              type="error"
              closable
              onClose={handleAlertClose}
              className={styles.alert}
            />
          )}
          <SettingsList />
          <Cell
            title={callDirectionsText.get(callDirection)}
            content={subscriber?.phone || '-'}
          />
          <Cell
            title="Управляющая компания"
            content={subscriber?.serviceCompany || '-'}
          />
          {isDispatcher && <ChooseCompany />}
          <PhoneNumberInput />
          <Actions className={cn(notDraggableClass, styles.centered)} />
          <ActiveCalls blockInstallationOwnerData={newRequestModalVisible} />
          <MissedCalls blockInstallationOwnerData={newRequestModalVisible} />
        </section>
      </div>
    </Popover>
  );
};

export default ControlPanel;
